import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { ProductCard } from '@notino/react-styleguide';

import { useFormatPrice } from '@components/PriceLabel/useFormattedPrice';
import { IConditionalFreeDelivery } from '@containers/ProductDetailContainer/ProductDetail/ProductBaseInfo/ConditionalFreeDelivery/model';
import { styled } from '@linaria/react';

type Props = {
  delivery: IConditionalFreeDelivery;
  product: { brand: { name: string } };
};

const Description = styled.div`
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.25rem;
`;

export const ProductTileConditionalFreeDelivery = ({
  delivery,
  product: { brand },
}: Props) => {
  const formatPrice = useFormatPrice();

  const getDescription = () => {
    const isBrandTargeted = delivery.targets[0]?.type === 'Brand';
    const freeDeliveryLabel = (
      <strong>
        <FormattedMessage id="productCard.discount.freeDelivery" />
      </strong>
    );

    if (isBrandTargeted) {
      if (delivery.type === 'Piece') {
        return (
          <FormattedMessage
            id="productCard.discount.freeDeliveryOnBrandPcs"
            values={{
              freedelivery: freeDeliveryLabel,
              brand: brand.name,
              count: delivery.value,
            }}
          />
        );
      }
      if (delivery.type === 'Price') {
        return (
          <FormattedMessage
            id="productCard.discount.freeDeliveryOnBrandPriceFrom"
            values={{
              freedelivery: freeDeliveryLabel,
              brand: brand.name,
              price: formatPrice({ value: delivery.value })!
                .formattedPriceWithCurrency,
            }}
          />
        );
      }
    }

    if (delivery.type === 'Piece') {
      return (
        <FormattedMessage
          id="productCard.discount.freeDeliveryOnCategoryPcs"
          values={{
            freedelivery: freeDeliveryLabel,
            count: delivery.value,
          }}
        />
      );
    }
    if (delivery.type === 'Price') {
      return (
        <FormattedMessage
          id="productCard.discount.freeDeliveryOnCategoryPriceFrom"
          values={{
            freedelivery: freeDeliveryLabel,
            price: formatPrice({ value: delivery.value })!
              .formattedPriceWithCurrency,
          }}
        />
      );
    }
  };

  const DiscountComponent = ProductCard.Discount;

  if (!DiscountComponent) {
    return null;
  }

  return (
    <DiscountComponent
      discountDescription={<Description>{getDescription()}</Description>}
    />
  );
};
